import { Box, Button, Checkbox, Grid, Paper, Snackbar, Table, TableBody, TableContainer, TableHead, TablePagination, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from '../../../styles.module.css';
import { useDispatch, useSelector } from "react-redux";

import { ActionMsg, AddButton, Breadcrumb, CustomePopover, DateConversionOnEntryPage, DeleteDialog, ExcelDownload, HandleCloseSnackbar, HandleSort, SearchInput, StyledTableCell, StyledTableRow, useMessageHandler } from "../../reusableComponent/Reusables";
//import { rows } from './../MastersFakeDb';
import { editDeleteEci, getEciList } from "../../../actions/actions";

const ViewCylinderList = () => {
    const dispatch = useDispatch();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;

    const [isDelete, setIsDelete] = useState(false);
    const [deleteInfo, setDeleteInfo] = useState();
    const [sortBy, setSortBy] = useState(null);

    const rows = useSelector(state => state.eci.eci)
    console.log("row s",rows);
    const [searchKey, setSearchKey] = useState('');


    const fields = ['id', "rm_code", "rm_name"];
    const labels = ['Id', "rm_code", "rm_name"];

    // const [successMessage, setSuccessMessage] = useState(null);
    // const respMsgState = 'test'
    // const respMsgState = useSelector((state) => state.rm.message);
  const [total_count,setTotalCount]=useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
    const [controller, setController] = useState({
        page: 0,
        rowsPerPage: 10
    });

    const handleChangePage = (event, newPage) => {
        setController({
            ...controller,
            page: newPage
        });
    };

    const handleChangeRowsPerPage = (event) => {
        setController({
            ...controller,
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        });
    };

    const fetchData = () => {
        const params = {
            page: controller.page,
            size: controller.rowsPerPage,
            searchKey: searchKey,
        }
        dispatch(getEciList(params))
    };

    const handleSearch = (e) => {
        setSearchKey(e.target.value)
        const params = {
            page: controller.page,
            size: e.target.value === '' ? controller.rowsPerPage : (rows[0]?.total_count || 0),
            searchKey: e.target.value,
        }
        dispatch(getEciList(params))
    }

    useEffect(() => {
        fetchData()
    }, [controller]);

    // const { shouldShowMsg, responseMessage } = useMessageHandler( null, setSuccessMessage, respMsgState);

    // useEffect(() => {
    // }, [shouldShowMsg, responseMessage,]);

    const deleteRecord = (id) => {
        dispatch(editDeleteEci({ eci_id: id, changedUpdatedValue: 'delete' }))
        setIsDelete(false);
        fetchData()
    }

    const handleDelete = (functions) => {
        setIsDelete(true);
        setDeleteInfo(functions);
    }

    const handleClose = (event, reason) => {
        setIsDelete(false)
        setDeleteInfo(null);
    };

    const [successMessage, setSuccessMessage] = useState(null);
            //const respMsgState = 'test'
            const respMsgState = useSelector((state) => state.eci.message);
    
            const { shouldShowMsg, responseMessage } = useMessageHandler(fetchData,null, setSuccessMessage, respMsgState);
                 useEffect(() => {
                        if (respMsgState) {
                            setSuccessMessage(respMsgState);
                        }
                    }, [respMsgState]);
                useEffect(() => {
                }, [shouldShowMsg, responseMessage,]);
    

    return (
        <>
            <Paper className={`${styles.cts_page}`}>
                {/* <Breadcrumb
                    routeSegments={[
                        // { name: 'Dashbord', path: '/dashboard' },
                        { name: 'Empty Cylinder Inspection List' },
                    ]}
                /> */}
                <Box sx={{ display: 'flex' }}>
                    <Grid container spacing={2} sx={{ pt: 1.5, pb: 1.5 }}>
                        <Grid item md={7} sm={6} xs={12}>
                            <Box sx={{ display: 'flex' }}>
                                <Typography className={`${styles.form_title}`} >
                                    Empty Cylinder Inspection List
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item md={5} sm={6} xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            {/* <Box className={`${styles.excel_box}`}>
                                <ExcelDownload
                                    data={rows}
                                    // data={rowsWithSerialNumbers}  ----- if want to Sr. No in the excel sheet ----
                                    fields={fields}
                                    labels={labels}
                                    filename="Empty Cylinder Inspection List"
                                />
                            </Box> */}
                            <SearchInput
                                value={searchKey}
                                onChange={handleSearch}
                            />
                            {/* <AddButton to="/storeEntries/add-eci" label="" /> */}
                        </Grid>
                    </Grid>
                </Box>
                <TableContainer component={Paper} className={`${styles.list_tbl_container}`} style={{ maxHeight: "400px", overflowY: "auto",width:"100%" }}>
                    <Table size="small" stickyHeader>
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell align="center" className={`${styles.table_head}`}>Action</StyledTableCell>
                                <StyledTableCell align="right" className={`${styles.table_head}`} onClick={() => HandleSort('entry_no', sortBy, setSortBy, rows)}>Entry No<span className={`${styles.sort_icon}`}> {sortBy === 'entry_no' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="center" className={`${styles.table_head}`} onClick={() => HandleSort('date', sortBy, setSortBy, rows)}>Date<span className={`${styles.sort_icon}`}> {sortBy === 'date' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="center" className={`${styles.table_head}`} onClick={() => HandleSort('cyl_no', sortBy, setSortBy, rows)}>Cylinder No<span className={`${styles.sort_icon}`}> {sortBy === 'cyl_no' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="center" className={`${styles.table_head}`} onClick={() => HandleSort('result', sortBy, setSortBy, rows)}>Result<span className={`${styles.sort_icon}`}> {sortBy === 'result' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="center" className={`${styles.table_head}`} onClick={() => HandleSort('current_tare_wt', sortBy, setSortBy, rows)}>Current Tare Wt<span className={`${styles.sort_icon}`}> {sortBy === 'current_tare_wt' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="center" className={`${styles.table_head}`} onClick={() => HandleSort('actual_tare_wt', sortBy, setSortBy, rows)}>Actual Tare Wt<span className={`${styles.sort_icon}`}> {sortBy === 'actual_tare_wt' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="center" className={`${styles.table_head}`} onClick={() => HandleSort('acetone_drum_tag_no', sortBy, setSortBy, rows)}>Acetone Drum Tag No<span className={`${styles.sort_icon}`}> {sortBy === 'acetone_drum_tag_no' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="center" className={`${styles.table_head}`} onClick={() => HandleSort('valve_condition', sortBy, setSortBy, rows)}>Valve Condition<span className={`${styles.sort_icon}`}> {sortBy === 'valve_condition' ? '▲' : '▼'} </span></StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {Array.isArray(rows) && rows.map((row, index) => (
                                <StyledTableRow
                                    key={row.entry_no}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                    <StyledTableCell align="center" >
                                        {/* <CustomePopover row={row} handleDelete={false} linkTo="/storeEntries/add-eci" /> */}
                                        <Checkbox
                                                  //  checked={
                                                  //     !!selectedRows[`${row.so_no}-${detailIndex}`]
                                                  //   }
                                                  //   onChange={() =>
                                                  //     handleCheckboxChange(
                                                  //       `${row.so_no}-${detailIndex}`
                                                  //     )
                                                  //   }
                                                 />
                                    </StyledTableCell>
                                    <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.entry_no}</StyledTableCell>
                                    <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.date}</StyledTableCell>
                                    <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.cyl_no}</StyledTableCell>
                                    <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.result}</StyledTableCell>
                                    <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.current_tare_wt}</StyledTableCell>
                                    <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.actual_tare_wt}</StyledTableCell>
                                    <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.acetone_drum_tag_no}</StyledTableCell>
                                    <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.valve_condition}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                {/* <TablePagination
                    component="div"
                    onPageChange={handleChangePage}
                    page={controller.page}
                    count={rows && (rows[0]?.total_count || 0)}
                    rowsPerPage={controller.rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                /> */}
                <DeleteDialog
                    open={isDelete}
                    handleClose={handleClose}
                    deleteInfo={deleteInfo}
                    deleteRecord={deleteRecord}
                    deleteID={deleteInfo?.eci_id || null}
                    displayName={deleteInfo?.eci_id || ''}
                />
                <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    open={successMessage ? true : false}
                    autoHideDuration={2000}
                    onClose={(event, reason) => HandleCloseSnackbar(event, reason, setSuccessMessage)}
                    message={successMessage}
                    action={ActionMsg(setSuccessMessage)}
                />
                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    //onClick={handleSubmit}
                    sx={{ mr: 2 }}
                  >
                    Submit
                  </Button>
                  <Button variant="contained" color="secondary" 
                  //onClick={handleCancel}
                    >
                    Clear
                  </Button>
                </Box>
            </Paper>
        </>
    )
}
export default ViewCylinderList;


